export const isDev = process.env.REACT_APP_IS_DEV?.toString() === 'true';
export const isProd = process.env.REACT_APP_IS_DEV?.toString() === 'false';
